export default "__VITE_ASSET__618244d9__"